import React from "react";
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView,
  MDBIcon,
  MDBAnimation,
} from "mdbreact";

const CarouselPage = () => {
  return (
    <MDBAnimation reveal type="fadeInLeft" duration="1000ms">
      <div className="clue">
        Hover to <br /> Stop Slider
      </div>
      <MDBCarousel
        activeItem={1}
        length={3}
        showControls={true}
        showIndicators={true}
        className="z-depth-1"
      >
        <MDBCarouselInner>
          <MDBCarouselItem itemId="1">
            <MDBView>
              <img
                className="d-block w-100"
                src="https://media0.giphy.com/media/RinJNRwFyYGDNCERFY/giphy.gif"
                alt="Second slide"
              />
            </MDBView>
            <div className="carousel-caption">
              <h3 className="h3-responsive">Restaurant Management Website</h3>
              <a
                className="hosting_anchor"
                href="https://www.fiverr.com/mamba_devs?up_rollout=true"
                target="_blank"
              >
                Get Hosting
              </a>
              <a className="live_anchor" href="#">
                <MDBIcon icon="play"></MDBIcon>
              </a>
              <h2>_</h2>
            </div>
            <div className="mobile-carousel"></div>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="2">
            <MDBView>
              <img
                className="d-block w-100"
                src="https://media3.giphy.com/media/efrp6ePMTkX58VsBg8/giphy.gif"
                alt="Second slide"
              />
            </MDBView>
            <div className="carousel-caption">
              <h3 className="h3-responsive">Hospital Management Website</h3>
              <a
                className="hosting_anchor"
                href="https://www.fiverr.com/mambadevelopers?up_rollout=true"
                target="_blank"
              >
                Get Hosting
              </a>
              <a
                className="live_anchor"
                href="https://medcityhospital.pk/"
                target="_blank"
              >
                <MDBIcon icon="play"></MDBIcon>
              </a>
              <h2>_</h2>
            </div>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="3">
            <MDBView>
              <img
                className="d-block w-100"
                src="https://media2.giphy.com/media/dwFO82EkpHMdcm9tiS/giphy.gif"
                alt="Second slide"
              />
            </MDBView>
            <div className="carousel-caption">
              <a
                className="hosting_anchor"
                href="https://www.fiverr.com/mambadevelopers?up_rollout=true"
                target="_blank"
              >
                Get Hosting
              </a>
              <a className="live_anchor" href="#">
                <MDBIcon icon="play"></MDBIcon>
              </a>
              <h2>_</h2>
            </div>
          </MDBCarouselItem>
        </MDBCarouselInner>
      </MDBCarousel>

      <div className="carousel-mobilecaption">
        <a className="hosting_anchor" href="#">
          Get Hosting
        </a>
      </div>
    </MDBAnimation>
  );
};

export default CarouselPage;
